export default __webpack_public_path__ + "static/media/Butch Blue Label Dog Food.b3e18148.png";